import { h } from "@stencil/core";
import { PrefillData } from "@trumpf/mf-service-calls/dist/types";
import { defineCustomElements } from "@trumpf/mf-service-calls/loader";

defineCustomElements();

export interface ServiceCaseCreateModalProps {
    modalName: string;
    locale: string;
    env: string;
    legacyApi?: boolean;
    prefillData?: PrefillData;
}

export const ServiceCaseCreateModal = ({
    env,
    legacyApi,
    prefillData,
    locale,
    modalName
}: ServiceCaseCreateModalProps) => {
    return (
        <mf-create-service-case-modal
            modalName={modalName}
            env={env}
            legacyApi={legacyApi}
            prefillData={prefillData}
            locale={locale}
            file-upload
        >
            <ux-f-sis-create-case-connector slot="connector"></ux-f-sis-create-case-connector>
        </mf-create-service-case-modal>
    );
};
